/**
 * Devuelve unos getter para centralizar y cachear la consulta de variables css.
 * No se implementan setter, de momento, la idea, es que solo se pueda settear usando los api de temas: skin.set o density.set
 */

let cache = {
  // cssVariables -> cache de getComputedStyle(document.documentElement) para evitar hacer getComputedStyle que es muy costozo
  // '--ewc-...': value -> nombre de variables con su valor que guardamos en cache cuando se pide
};

/**
 * Borra la cache, llamar esta función cuando se cambia el valor de skin o density
 */
export function invalidCache() {
  cache = {};
}

/**
 * Devuelve el valor de la propiedad.
 *
 * @param {string} name el nombre de la propiedad, ej: '--ewc-mi-variable'
 * @return {string}
 */
export function getValue(name) {
  if (typeof name !== 'string') {
    if (Array.isArray(name)) {
      return getProperties(name);
    }
    throw new Error(`getValue: argument must be a string`);
  }
  if (!cache.hasOwnProperty(name)) {
    cache.cssVariables = cache.cssVariables || getComputedStyle(document.documentElement);
    /**
     * el .replace(/\\/g, '') es para:
     * @example logo 'url(.\\.\\/base\\/imgs\\/LOGO_WEB_DELHAIZE\\.png)' -> 'url("../base/imgs/LOGO_WEB_DELHAIZE.png")'
     */
    const value = cache.cssVariables.getPropertyValue(name).replace(/\\/g, '');
    cache[name] = value;
  }
  return cache[name];
}

/**
 * Devuelve un array de valores de las propiedades
 *
 * @param {string[]} names Array de nombres de variables css
 * @return {string[]}
 */
export function getValues(names) {
  if (!Array.isArray(names)) {
    throw new Error(`getValues: argument must be an array`);
  }

  return names.map(name => {
    return getValue(name);
  });
}

/**
 * Devuelve un objeto de tipo {<nombre variable>: <valor>, ...}
 *
 * @param {string[]} names Array de nombres de variables css
 * @return {object<name: value>}
 */
export function getProperties(names) {
  if (!Array.isArray(names)) {
    throw new Error(`getProperties: argument must be an array`);
  }

  return names.reduce((acc, name) => {
    acc[name] = getValue(name);
    return acc;
  }, {});
}
